import { render } from "./edit-perencanaan.vue?vue&type=template&id=0d6e9318"
import script from "./edit-perencanaan.vue?vue&type=script&lang=js"
export * from "./edit-perencanaan.vue?vue&type=script&lang=js"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__